import React from 'react';
import { motion } from 'framer-motion';

const Services = () => {
  const services = [
    {
      id: 'diseno',
      title: 'Diseño e Ingeniería',
      description: [
        'Elaboración de planos técnicos y de construcción.',
        'Modelado en 3D y renderización de proyectos.',
        'Análisis estructural mediante software especializado.',
        'Ingeniería de valor para optimizar costos y recursos.',
        'Diseño CAD/BIM avanzado para proyectos complejos.'
      ],
      image: '/assets/services/Glass-Enclosed Skywalk Installation.png'
    },
    {
      id: 'fabricacion',
      title: 'Fabricación y Montaje Industrial',
      description: [
        'Fabricación de estructuras metálicas.',
        'Montaje de equipos industriales.',
        'Soldadura especializada y corte térmico.',
        'Control de calidad en procesos de fabricación.'
      ],
      image: '/assets/services/Workshop Fabrication.png'
    },
    {
      id: 'mantenimiento',
      title: 'Mantenimiento y Acabados Industriales',
      description: [
        'Inspección y evaluación de estructuras metálicas.',
        'Refuerzo/sustitución de elementos estructurales defectuosos.',
        'Programas de mantenimiento preventivo.',
        'Soluciones Integrales de Pintura Industrial.',
        'Recubrimientos protectores y anticorrosivos.'
      ],
      image: '/assets/services/Structural Damage Inspection Oxidation Corrosion.png'
    },
    {
      id: 'consultoria',
      title: 'Consultoría y Asesoramiento',
      description: [
        'Asesoramiento técnico en la selección de materiales.',
        'Consultoría en normativas y regulaciones de construcción.',
        'Evaluación de factibilidad técnica y económica de proyectos.',
        'Apoyo en la planificación y gestión de proyectos.',
        'Soporte técnico durante todas las etapas del proyecto.'
      ],
      image: 'próximamente'
    },
    {
      id: 'gestion',
      title: 'Gestión de Proyectos',
      description: [
        'Planificación y control de cronogramas.',
        'Gestión de recursos humanos y materiales.',
        'Coordinación de actividades multidisciplinarias.',
        'Control de calidad y seguridad en obra.',
        'Supervisión de instalaciones mecánicas y eléctricas.'
      ],
      image: '/assets/services/Side Completed Installation.png'
    },
    {
      id: 'soluciones',
      title: 'Soluciones Personalizadas',
      description: [
        'Desarrollo de soluciones a medida para necesidades específicas.',
        'Optimización de procesos industriales.',
        'Automatización de sistemas de producción.',
        'Integración de tecnologías emergentes.',
        'Asistencia técnica post-instalación.'
      ],
      image: '/assets/services/Hydraulic Testing Equipment.png'
    }
  ];

  return (
    <section 
      id="servicios" 
      className="py-20 bg-gradient-to-b from-gray-50 to-white"
    >
      <div className="container-standard px-4">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-heading font-bold text-primary-800 mb-4">Nuestros Servicios</h2>
          <div className="w-20 h-1 bg-primary-accent mx-auto"></div>
          <p className="mt-6 text-body-lg text-gray-600 max-w-3xl mx-auto">
            Ofrecemos una amplia gama de servicios, desde la ingeniería hasta la ejecución de obras de gran envergadura.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={service.id}
              className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100 card-elevated flex flex-col h-full"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className="p-6 flex-grow">
                <h3 className="text-subheading font-bold text-primary-800 mb-4 text-center">{service.title}</h3>

                <div className="flex justify-center mb-4">
                  {service.image === 'próximamente' ? (
                    <div className="bg-gray-200 border-2 border-dashed rounded-xl w-16 h-16 flex items-center justify-center text-gray-500">
                      <span className="text-xs text-center">Próximamente</span>
                    </div>
                  ) : (
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-48 object-cover rounded-xl"
                    />
                  )}
                </div>

                <ul className="space-y-2">
                  {service.description.map((item, idx) => (
                    <li
                      key={idx}
                      className="flex items-start text-gray-700 text-small"
                    >
                      <span className="text-accent-500 mr-2 mt-1 flex-shrink-0">✓</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-gradient-to-r from-primary-dark to-primary-accent h-1 w-full"></div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;